export const TEMP_LAYER_NAME_GRAFFITI="graffiti_draw"
export const TEMP_LAYER_NAME_GRAFFITI_LINE="graffiti_draw_line"

export const TEMP_LAYER_NAME_SELECT="selectionSetDraw"
export const TEMP_LAYER_NAME_SELECT_SUFFIX="_select"
export const TEMP_LAYER_NAME_SPLIT_SELECT_SUFFIX="_split_select"


export const EVENT_MAP_TOOL_BIND="tool_bind"
export const EVENT_MAP_TOOL_REMOVE="tool_remove"
export const EVENT_MAP_TOOL_ACTIVE="tool_active"
export const EVENT_MAP_TOOL_IN_ACTIVE="tool_inactive"



// WEBPACK FOOTER //
// ./src/tool/edit/Constants.js